import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=264ed9c6&scoped=true"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=264ed9c6&prod&scoped=true&lang=less"
import style1 from "./reward.vue?vue&type=style&index=1&id=264ed9c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ed9c6",
  null
  
)

export default component.exports